import { PARTNER360_NAMESPACE } from '../common/constants'

export const PARTNER360_BASIC_INFO_NAMESPACE = `${PARTNER360_NAMESPACE}/basicInfo`

// Async thunk constants
export const REQUEST_BASIC_INFO_DATA = `${PARTNER360_BASIC_INFO_NAMESPACE}/requestBasicInfoData`
export const CREATE_BASIC_INFO_DATA = `${PARTNER360_BASIC_INFO_NAMESPACE}/createBasicInfoData`
export const CREATE_DEFAULT_BASIC_INFO_DATA = `${PARTNER360_BASIC_INFO_NAMESPACE}/createDefaultBasicInfoData`
export const UPDATE_BASIC_INFO_DATA = `${PARTNER360_BASIC_INFO_NAMESPACE}/updateBasicInfoData`
export const UPDATE_DEFAULT_BASIC_INFO_DATA = `${PARTNER360_BASIC_INFO_NAMESPACE}/updateDefaultBasicInfoData`
